import { Show, SignInButton, SignUpButton, ClerkLoading, ClerkLoaded } from '@clerk/react';
import { Navigate } from 'react-router-dom';
import { ThemeToggle } from '@/components/ThemeToggle';

/**
 * Public landing page at "/".
 *
 * - Signed-in users are redirected to /dashboard.
 * - Signed-out users see a brief explainer with sign-in and sign-up CTAs.
 */
export function Landing() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-12 sm:px-6 lg:px-8">
      <ClerkLoading>
        <div className="flex min-h-[40vh] items-center justify-center">
          <div className="text-sm text-slate-500 dark:text-slate-400">Loading…</div>
        </div>
      </ClerkLoading>

      <ClerkLoaded>
        <Show when="signed-in">
          <Navigate to="/dashboard" replace />
        </Show>

        <Show when="signed-out">
          <header className="mb-12 flex items-center justify-between">
            <h1 className="text-xl font-bold text-slate-900 dark:text-slate-100">WanEntry</h1>
            <ThemeToggle />
          </header>

          <main className="text-center">
            <h2 className="mb-4 text-3xl font-bold tracking-tight text-slate-900 dark:text-slate-100 sm:text-4xl">
              Simple accounting for Solomon Islands businesses
            </h2>
            <p className="mx-auto mb-8 max-w-xl text-base text-slate-600 dark:text-slate-400">
              Record one transaction, get proper double-entry bookkeeping. No journals to balance,
              no jargon to learn.
            </p>

            <div className="flex flex-col items-center justify-center gap-3 sm:flex-row">
              <SignInButton mode="modal">
                <button
                  type="button"
                  className="inline-flex h-11 items-center justify-center rounded-md border border-slate-300 bg-white px-6 text-sm font-medium text-slate-900 transition hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:bg-slate-800"
                >
                  Sign in
                </button>
              </SignInButton>

              <SignUpButton mode="modal">
                <button
                  type="button"
                  className="inline-flex h-11 items-center justify-center rounded-md bg-brand-600 px-6 text-sm font-medium text-white transition hover:bg-brand-700"
                >
                  Get started
                </button>
              </SignUpButton>
            </div>

            <p className="mt-12 text-xs text-slate-500 dark:text-slate-500">
              WanEntry is currently in closed beta. Sign-ups go to a waitlist.
            </p>
          </main>
        </Show>
      </ClerkLoaded>
    </div>
  );
}
